const TEXT = "#EDEDED";
const TEXT_DIM = "#a0a0a0";

// Decode common HTML entities so questions/answers carrying &#39;, &quot;,
// &ldquo;, etc. render as real characters (lets pages drop inline .replace()).
const ENTITIES = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'", "&apos;": "'", "&ldquo;": "“", "&rdquo;": "”", "&lsquo;": "‘", "&rsquo;": "’", "&ndash;": "–", "&mdash;": "—", "&hellip;": "…", "&nbsp;": " " };
function decode(s) {
  if (typeof s !== "string") return s;
  let out = s;
  for (const [k, v] of Object.entries(ENTITIES)) out = out.split(k).join(v);
  out = out.replace(/&#x([0-9a-fA-F]+);/g, (_, h) => String.fromCodePoint(parseInt(h, 16)));
  out = out.replace(/&#(\d+);/g, (_, d) => String.fromCodePoint(parseInt(d, 10)));
  return out;
}

// Stable bookmark id for an FAQ question (first ~8 words slugified), e.g.
// "How do I track conversions?" -> "faq-how-do-i-track-conversions".
function faqSlug(q) {
  return (
    "faq-" +
    String(q)
      .toLowerCase()
      .replace(/['‘’]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .split("-")
      .slice(0, 8)
      .join("-")
  );
}

/**
 * Shared FAQ item renderer for blog posts + glossary terms.
 *
 * Replaces each page's inline `{faqs.map(...)}` block. Renders every question
 * as an addressable, bookmarked <h3 id="faq-..."> with a hover-revealed "#"
 * deep-link, so AI crawlers and Google can reference a single answer (and
 * readers can grab a link to it). Server-rendered: the anchors live in the HTML.
 *
 * The page keeps its own <H2 id="faq"> heading and its FAQPage JSON-LD schema
 * (both built from the same `faqs` array). Matches the standard blog/glossary
 * H3 (19px) + P (16px) styling so migrated pages render identically.
 *
 * Props: faqs = [{ q: string, a: string | ReactNode }, ...]
 */
export default function FAQItems({ faqs }) {
  return (
    <>
      {faqs.map((faq, i) => {
        const q = decode(faq.q);
        const id = faqSlug(q);
        const a = decode(faq.a);
        return (
          <div
            key={i}
            style={{ marginBottom: 24, paddingBottom: 24, borderBottom: "1px solid rgba(255,255,255,0.06)" }}
          >
            <h3
              id={id}
              className="anchored-heading"
              style={{
                fontFamily: "var(--display)",
                fontWeight: 700,
                fontSize: 19,
                color: TEXT,
                margin: "32px 0 12px",
                letterSpacing: "-0.005em",
                lineHeight: 1.3,
                position: "relative",
                scrollMarginTop: 88,
              }}
            >
              <a href={`#${id}`} className="heading-anchor" aria-label="Link to this question">
                #
              </a>
              {q}
            </h3>
            <p style={{ fontFamily: "var(--body)", fontSize: 16, color: TEXT_DIM, lineHeight: 1.85, margin: "0 0 18px" }}>
              {a}
            </p>
          </div>
        );
      })}
    </>
  );
}
